import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { Chip, Stack } from '@mui/material';
import type { ReactElement } from 'react';
import { reportPackageLabels, reportPackageStatusLabels } from '../../constants/reportLabels';
import type { ReportPackage, ReportPackageKey, ReportPackageStatus } from '../../types';

interface ReportPackageChipsProps {
  keys: ReportPackageKey[];
  packages: Record<ReportPackageKey, ReportPackage>;
}

const STATUS_STYLES: Record<ReportPackageStatus, { color: 'success' | 'warning' | 'default'; icon: ReactElement }> = {
  up_to_date: { color: 'success', icon: <CheckCircleOutlineIcon /> },
  stale: { color: 'warning', icon: <WarningAmberIcon /> },
  missing: { color: 'default', icon: <RemoveCircleOutlineIcon /> },
};

/** The status is spelled out in the label so it never relies on color alone. */
const ReportPackageChips = ({ keys, packages }: ReportPackageChipsProps) => (
  <Stack direction="row" useFlexGap flexWrap="wrap" gap={0.5} component="ul" sx={{ listStyle: 'none', p: 0, m: 0 }}>
    {keys.map((key) => {
      const status = packages[key]?.status ?? 'missing';
      const { color, icon } = STATUS_STYLES[status];
      return (
        <li key={key}>
          <Chip
            size="small"
            variant="outlined"
            color={color}
            icon={icon}
            label={`${reportPackageLabels[key]}: ${reportPackageStatusLabels[status]}`}
          />
        </li>
      );
    })}
  </Stack>
);

export default ReportPackageChips;
